import * as React from 'react';
import { connect } from 'react-redux';
import { select } from '@rematch/select';
import { withRouter } from 'react-router-dom';
import { Trans } from 'react-i18next';

import { CourseCard } from '../../atoms/course-card';
import { Text } from '../../atoms/text';
import { can } from '../../utils/permissions';

class Renderer extends React.Component {
  static defaultProps = {
    noCourseMessage: <Trans>No programs</Trans>,
  };

  render() {
    const { courses, noCourseMessage } = this.props;
    if (courses.length === 0) {
      return <Text>{noCourseMessage}</Text>;
    }

    return (
      <div className="row" style={{ marginLeft: -10, marginRight: -10 }}>
        {courses.map((course) => (
          <div className="col-xs-4" style={{ marginBottom: 24, paddingRight: 12, paddingLeft: 12 }} key={course.id}>
            <CourseCard
              course={course}
              viewer={this.props.viewer}
              onRequestCourse={() =>
                this.props.history.push(
                  `/courses/${course.id}/${can(course, 'Course', 'isMemberOfProgram') ? 'timeline' : 'about'}`,
                )
              }
              onEditCourse={() => this.props.history.push(`/courses/${course.id}/update`)}
              onDeleteCourse={() => this.props.deleteCourse(course)}
              onFinishCourse={() => this.props.finishCourse(course)}
              onPublishCourse={() => this.props.publishCourse(course)}
              onReportCourse={() => this.props.reportCourse(course)}
              onDuplicateCourse={() => this.props.duplicateCourse(course)}
              onHandleJoin={this.props.onHandleJoin}
            />
          </div>
        ))}
      </div>
    );
  }
}

const mapState = (state, props) => ({
  viewer: select.session.user(state),
});

export const CoursesList = withRouter(connect(mapState)(Renderer));
